const { pathname, hostname } = window.location;

export const cityRouterReg = /^\/city-[A-Za-z0-9]+\//; // ${domain}/city-xx/xx 城市分站路由规则@振杰
export const citySiteReg = /^\/city-[A-Za-z0-9]+\/$/;
export const cityZhaoPinReg = /^\/city-[A-Za-z0-9]+\/zhaopin\//;
export const isWWW = hostname === 'www.liepin.com';
export const isC = hostname === 'c.liepin.com';
export const isCitySite = citySiteReg.test(pathname);
export const isCityRouter = cityRouterReg.test(pathname);
export const isCityZhaoPin = cityZhaoPinReg.test(pathname);
export const needCheckCity = isCitySite || isCityZhaoPin;
